import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Badge } from '@motorway/mw-highway-code';
import { BADGE_VARIANT } from '@motorway/mw-highway-code/enums';

import { HighDemandFireIcon } from './HighDemandFireIcon';
import LocalTexts from './HighDemandVehicle.texts.json';

import styles from './HighDemandVehicle.module.scss';

const LocalT = new MDText(LocalTexts);

export const HighDemandBadge = ({ className }: { className?: string }) => (
  <div className={cx(styles.badge, className)} data-testid='highDemandBadge'>
    <Badge
      reverse
      icon={HighDemandFireIcon}
      text={String(LocalT.translate('badgeLabel'))}
      variant={BADGE_VARIANT.DEFAULT}
    />
  </div>
);
